namespace AnyMap {
  export type Any = Map<any, any> | WeakMap<any, any>;
  export type Key<M extends Any> = M extends { get: (key: infer Key) => any }
    ? Key
    : never;
  export type Value<M extends Any> = M extends {
    set: (key: any, value: infer Value) => void;
  }
    ? Value
    : never;
  export function getOr<M extends Any>(
    map: M,
    key: Key<M>,
    defaultValue: Value<M>
  ): Value<M> {
    if (!map.has(key)) {
      map.set(key, defaultValue);
    }
    return map.get(key);
  }
  getOr.lazy = (() => {
    function lazy<M extends Any>(
      map: M,
      key: Key<M>,
      getDefaultValue: () => Value<M>
    ): Value<M>;
    function lazy<M extends Any, D>(
      map: M,
      key: Key<M>,
      getDefaultValue: () => D
    ): Value<M> | D;
    function lazy<M extends Any, D>(
      map: M,
      key: Key<M>,
      getDefaultValue: () => D
    ): Value<M> | D {
      if (!map.has(key)) {
        map.set(key, getDefaultValue());
      }
      return map.get(key);
    }
    return lazy;
  })();
}

export default AnyMap;
